import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TemplatesService as GeneratedTemplatesService } from '@generated/tcea/services/templates.service';
import {
  TemplateCreateBody,
  TemplatesAbstractClass,
  TemplateUpdateBody,
} from '@abstract-services/templates/1.0/templates.abstract-class';
import { map } from 'rxjs/operators';
import { TemplateResponse } from '@generated/tcea/models/template-response';
import { TemplateType } from '@generated/tcea/models';
import { TemplateCreate$Params } from '@generated/tcea/fn/templates/template-create';
import { TemplateUpdate$Params } from '@generated/tcea/fn/templates/template-update';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService implements TemplatesAbstractClass {
  constructor(private generatedTemplatesService: GeneratedTemplatesService) {}
  getAllTemplates(brandId: string, type: TemplateType): Observable<TemplateResponse[]> {
    return this.generatedTemplatesService
      .templateGetAll({
        templateType: type as TemplateType,
        'Active-Tenant-Identifier': brandId,
      })
      .pipe(
        map((res) => {
          if (res._embedded && res._embedded.template) {
            return res._embedded.template;
          }

          return [];
        }),
      );
  }

  createTemplate(brandId: string, body: TemplateCreateBody): Observable<TemplateResponse> {
    const params: TemplateCreate$Params = {
      templateType: body.templateType,
      'Active-Tenant-Identifier': brandId,
      body: body.TemplateCreateRequest,
    };

    return this.generatedTemplatesService.templateCreate(params);
  }

  updateTemplate(brandId: string, updateBody: TemplateUpdateBody): Observable<TemplateResponse> {
    const params: TemplateUpdate$Params = {
      ...updateBody,
      templateType: updateBody.templateType as any,
      'Active-Tenant-Identifier': brandId,
      body: updateBody.TemplateCreateRequest,
    };

    return this.generatedTemplatesService.templateUpdate(params);
  }
}
